import { ALL } from '../../../routes/path';
import { ProjectResponse } from '../../../models/projects/ProjectResponse';

// CTA target of an announcement: the user's current project (taken from the URL, non-demo — demo projects
// have no entry for these tabs in the menu) on the announced tab, else the bare tab route, which the
// router redirects to the first project.
export const projectTabPath = (
  tabRoute: string,
  pathname: string,
  projects: ProjectResponse[] | null
): string => {
  const projectIdInUrl = Number(pathname.match(/^\/[^/]+\/(\d+)(?:\/|$)/)?.[1]);
  const currentProject = projects?.find((project) => project.id === projectIdInUrl);
  return currentProject && !currentProject.demoVersion
    ? `${tabRoute}/${currentProject.id}/${currentProject.defaultPeriod.toLowerCase()}${ALL}`
    : tabRoute;
};
